import { createAsyncThunk } from '@reduxjs/toolkit';
import { Order } from '../../../client/services';
import { toastHandler } from '../../../utils/toastHandler';
import { normalizeOrderRecord } from '../../../utils/orderRecord';
import { FindOrder, GetOrder, Order as OrderType } from './interface';

export const findOrder = createAsyncThunk(
  'order/findOrder', async (values: FindOrder, { rejectWithValue }) => {
    try {
      const response = await Order.find({
        query: values,
      });

      return {
        ...response,
        data: Array.isArray(response?.data)
          ? response.data.map((order: OrderType) => normalizeOrderRecord(order))
          : response?.data,
      };
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  });

export const getOrder = createAsyncThunk(
  'order/getOrder',
  async ({ id }: GetOrder, { rejectWithValue }) => {
    try {
      const response = await Order.get(id);

      return normalizeOrderRecord(response);
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);
